// Chilean formatters

export function formatCLP(value) {
  const n = Number(value || 0);
  return "$ " + n.toLocaleString("es-CL", { maximumFractionDigits: 0 });
}

// Formatea solo dígitos con separador de miles chileno (1500000 -> "1.500.000")
export function formatThousands(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (!digits) return "";
  return Number(digits).toLocaleString("es-CL", { maximumFractionDigits: 0 });
}

export function cleanRut(rut) {
  return (rut || "").replace(/[^0-9kK]/g, "").toUpperCase();
}

export function formatRut(rut) {
  const c = cleanRut(rut);
  if (c.length < 2) return rut || "";
  const body = c.slice(0, -1);
  const dv = c.slice(-1);
  const withDots = body.split("").reverse().reduce((acc, ch, i) => {
    return acc + ch + ((i + 1) % 3 === 0 && i + 1 !== body.length ? "." : "");
  }, "").split("").reverse().join("");
  return `${withDots}-${dv}`;
}

export function validateRut(rut) {
  const c = cleanRut(rut);
  if (c.length < 2) return false;
  const body = c.slice(0, -1);
  const dv = c.slice(-1);
  if (!/^\d+$/.test(body)) return false;
  let total = 0;
  let mul = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    total += parseInt(body[i], 10) * mul;
    mul = mul === 7 ? 2 : mul + 1;
  }
  const mod = 11 - (total % 11);
  const expected = mod === 11 ? "0" : mod === 10 ? "K" : String(mod);
  return expected === dv;
}

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("es-CL", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("es-CL", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function formatTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleTimeString("es-CL", { hour: "2-digit", minute: "2-digit" });
}

/** Relative short label for chat list, e.g. "12:34", "Ayer", "Lun", "12 abr" */
export function relativeShort(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  if (sameDay) {
    return d.toLocaleTimeString("es-CL", { hour: "2-digit", minute: "2-digit" });
  }
  const yest = new Date(now);
  yest.setDate(now.getDate() - 1);
  if (d.toDateString() === yest.toDateString()) return "Ayer";
  const diffDays = Math.floor((now - d) / (1000 * 60 * 60 * 24));
  if (diffDays < 7) {
    return d.toLocaleDateString("es-CL", { weekday: "short" }).replace(".", "");
  }
  return d.toLocaleDateString("es-CL", { day: "2-digit", month: "short" });
}

export function apiError(e, fallback = "Ocurrió un error") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" · ");
  if (typeof d === "object" && d.message) return d.message;
  if (typeof d === "object" && d.msg) return d.msg;
  return JSON.stringify(d);
}
